import { parseDateTime, type CalendarDateTime } from '@internationalized/date';

const TIME_ZONE_OFFSET_PATTERN = /([+-]\d{2}:\d{2}|Z)$/;

/**
 * "2026-04-15T15:30:00+03:00" → "2026-04-15T15:30:00"
 *
 * The result is timezone-less, so `new Date()` reads it back as the very same
 * wall clock in any timezone.
 */
export function stripTimeZoneOffset(isoString: string): string {
  return isoString.replace(TIME_ZONE_OFFSET_PATTERN, '');
}

/**
 * Parses an ISO 8601 string without converting to the local timezone.
 * Strips the timezone offset, returning the wall-clock time as-is from the API.
 *
 * "2026-04-15T15:30:00+03:00" → { year: 2026, month: 4, day: 15, hour: 15, minute: 30 }
 */
export function parseLocalDateTime(isoString: string): CalendarDateTime {
  return parseDateTime(stripTimeZoneOffset(isoString));
}
